import { render, staticRenderFns } from "./refund_xq.vue?vue&type=template&id=747aa2fc&scoped=true&"
import script from "./refund_xq.vue?vue&type=script&lang=js&"
export * from "./refund_xq.vue?vue&type=script&lang=js&"
import style0 from "./refund_xq.vue?vue&type=style&index=0&id=747aa2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747aa2fc",
  null
  
)

export default component.exports